"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _FIELD_CONSTANTS = require("./mappings/FIELD_CONSTANTS");

/**
 * Custom AJV keyword, validates country state fields based on business logic
 *
 * usage:
 *     const ajv = ajvErrors(new Ajv({allErrors: true}))
 *     ajv.addKeyword('CountryState', CountryStateKeyword)
 *
 */
var _default = {
  /**
   * @return {boolean}
   */
  //stateRequired
  validate: function V(schema, data) {
    var stateRequired = schema.stateRequired;
    var mkto = schema.mkto;
    var fieldValueMap = (0, _FIELD_CONSTANTS.FIELD_VALUE_MAP)(mkto);

    if (typeof stateRequired === 'undefined') {
      stateRequired = true;
    }

    V.errors = [];
    var country = data.country,
        state = data.state;
    /** Possible error examples:
     * 'country' is required.
     * 'state' is required in country 'USA'.
     *  Received state 'Florida', but missing 'country'.
     * 'ABC' is not a valid 'country'.
     * 'XYZ' is not a valid state/province in "USA".
     **/
    //not required, nothing passed ==> PASS

    if (!schema.required && !country && !state) {
      return true;
    } //country required, not passed ==> FAIL


    if (schema.required && !country) {
      V.errors.push({
        keyword: "CountryState",
        message: "'country' is required."
      });
      return false;
    } //state passed, no country ==> FAIL


    if (state && !country) {
      V.errors.push({
        keyword: "CountryState",
        message: "Received state/province '".concat(state, "', but missing 'country'.")
      });
      return false;
    } //Country is NOT a known value ==> FAIL


    if (!fieldValueMap.country.includes(country)) {
      V.errors.push({
        keyword: "CountryState",
        message: "'".concat(country, "' is not a valid 'country'.")
      });
      return false;
    } //County is in the list of countries with defined states


    if (Object.keys(_FIELD_CONSTANTS.CC_STATE_MAP).includes(country)) {
      //State is present && state is required
      if (!state && stateRequired) {
        V.errors.push({
          keyword: "CountryState",
          message: "'state' is required in country '".concat(country, "'.")
        });
        return false;
      } //state is not a valid value for country ==> FAIL


      if (state && !_FIELD_CONSTANTS.CC_STATE_MAP[country].includes(state)) {
        V.errors.push({
          keyword: "CountryState",
          message: "'".concat(state, "' is not a valid state/province in '").concat(country, "'.")
        });
        return false;
      } //country is known, state is known for country ==> PASS


      return true;
    } //country valid, but not in the list of countries we define states for


    return true;
  },
  errors: true
};
exports.default = _default;
//# sourceMappingURL=CountryStateKeyword.js.map